<template>
  <div>接口列表</div>
</template>

<script>
  export default {
    name: "project-api-list"
  }
</script>

<style scoped>

</style>
